<template>
  <div class="download-app">
    <div class="title">下载App</div>
    <div class="bg">
      <div class="left">
        <img src="https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/download-text.png" alt="">
        <p>企业员工一键加油</p>
      </div>
      <div class="right">
        <app-qr-code ref="QrCodeRef" class="qrcode" :value="'https://a.app.qq.com/o/simple.jsp?pkgname=com.nl.chefu'" :size="50" level="L" />
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.download-app {
  border-radius: 16px;
  background: #fff;
  padding: 20px;
  margin-top: 16px;

  .title {
    color: #1d2129;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px; /* 160% */
    margin-bottom: 16px;
  }

  .bg {
    width: 363px;
    height: 152px;
    flex-shrink: 0;
    border-radius: 12px;
    background: 
      linear-gradient(270deg, rgba(251, 246, 255, 0.8) 0%, rgba(244, 248, 255, 0.8) 100%),
      url("https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/download-bg.png") center/contain no-repeat;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .left {
      img {
        width: 182px;
        margin-bottom: 8px;
      }

      p {
        color: #1d2129;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
      }
    }

    .right {
      width: 113px;
      height: 113px;
      padding: 7px;
      background: #fff;
      border-radius: 7px;
    }
  }
}
</style>
